import { Actions, UseHintState } from './types';

export const defaultState = (): UseHintState => ({
  showHint: false,
});

export const reducers = (state: UseHintState, action: Actions): UseHintState => {
  switch (action.type) {
    case 'SET_SHOW_HINT':
      return { ...state, showHint: action.payload.showHint };
  }
};
